import computed from './computed'
import data from './data'
import methods from './methods'
import validations from './validations'

export default {
  computed,
  data,
  methods,
  validations
}



// WEBPACK FOOTER //
// ./src/app/settings/dependents/resources/index.js